import * as React from 'react'

export const AidaPaneActiveContext = React.createContext(true)
